import React, { Component } from 'react'

/* kommt später aus app.js */
import { isMobile } from 'react-device-detect'
import DocumentAdd from './DocumentAdd'

var server

class Signature extends Component
{
    constructor( props, context )
    {
        super( props, context )

        let e = this.props.e || {}

        this.id = e.id || 'can'
        this.name = e.name || 'Unterschrift Besucher/in'
        this.required = e.required === 'true'
        this.app = this.props.app

        /* is required ?? eher ja! */
        /*  todo: save signature to cookie "signature_(+id) */
        /*  todo: read signature from cookie "signature_(+id)" */
        this.isMobile = e.isMobile || isMobile
        this.initialDataURL = this.dataURL = e.value || 'data:image/png;base64,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'
        this.img = this.create( this.initialDataURL )   
        this.penColor = e.penColor || '#666666'
        this.bgColor = e.bgColor || "#f7f7f7"
        this.penSize = parseInt( e.penSize || 3 )
        this.w = e.width || 1000
        this.h = e.height || 200

        this.canvas = null
        this.ctx = null
        this.flag = false
        this.prevX = 0
        this.currX = 0
        this.prevY = 0
        this.currY = 0
        this.dot_flag = false

        this.state = {
            value: Boolean( this.initialDataURL ),
            redBorder: false
        }

        this.toggleRedBorder = () => {
            let self = this

            setTimeout(function () {
                self.setState({ redBorder: !self.edited, value: self.edited })
            }, 30)
        }
    }

    componentDidMount()
    {
        server = window.server
        window.hideLoader()

        /* 
            verzögertes initialisieren
            des unterschriften-hintergrunds,
            da er sonst nicht immer initialisiert wurde
        */
        let self = this
        setTimeout(() => {
            
            self.init()
        }, 200);
    }


    saveToRenderData(){
        if( this.app ){

            let id = this.id
            let rd = this.app.renderData
    
            for (let i = 0; i < rd.length; i++) {
                const e = rd[ i ]
                
                let is_self = e.id === id && i === e.selfIndex
                if( is_self )
                    this.app.renderData[ i ].value = this.dataURL
            }
        }
    }


    init()
    {
        this.root = document.getElementById( 'root' );
        this.canvas = document.getElementById( this.id );
        this.ctx = this.canvas.getContext( "2d" );
        
        this.ctx.fillStyle = this.bgColor;
        this.ctx.fillRect(0, 0, this.w, this.h);

        if( this.initialDataURL ){

            this.img = this.create( this.initialDataURL );
            this.ctx.drawImage( this.img, 0, 0);
        }

        let self = this
        let mouse = {}

        if ( this.isMobile )
        {
            mouse = {
                move: "touchmove",
                start: "touchstart",
                end: "touchend"
            }
        }else
        {
            mouse = {
                move: "mousemove",
                start: "mousedown",
                end: "mouseup"
            }
        }

        this.canvas.addEventListener( mouse.move,   e => self.findxy( 'move', e ), false );
        this.canvas.addEventListener( mouse.start,  e => self.findxy( 'down', e ), false );
        this.canvas.addEventListener( mouse.end,    e => self.findxy( 'up', e ), false );
        this.root.addEventListener( mouse.end,    e => self.findxy( 'up', e ), false );
        /* touchcancel */
        /* this.canvas.addEventListener( "mouseout", function ( e )
        {
            self.findxy( 'out', e )
        }, false ); */
    }

    update(){
    }

    draw()
    {
        this.ctx.beginPath();
        this.ctx.moveTo( this.prevX, this.prevY );
        this.ctx.lineTo( this.currX, this.currY );
        this.ctx.strokeStyle = this.penColor;
        this.ctx.lineWidth = this.penSize;
        this.ctx.stroke();
        this.ctx.closePath();
    }

    erase()
    {
        this.edited = false // || Boolean( this.initialDataURL )
        
        this.ctx.clearRect( 0, 0, this.w, this.h );
        this.ctx.fillStyle = this.bgColor;
        this.ctx.fillRect(0, 0, this.w, this.h);
        
        if( this.initialDataURL ){
            this.img = this.create( this.initialDataURL );
            this.ctx.drawImage( this.img, 0, 0);
        }else{
            this.img = ''
        }

        this.dataURL = this.canvas.toDataURL()
        this.saveToRenderData()
        this.app.resetImageRef(this.id)

        // this.update()
        this.setState({ value: false })
    }

    save()
    {
        this.dataURL = this.canvas.toDataURL()
        this.img = this.create( this.dataURL )
        this.saveToRenderData()

        let file = this.dataURLtoFile( this.dataURL, this.id )
        this.app.setImageRef(this.id, file, file.type)
        //this.update()
    }

    dataURLtoFile(dataUrl, fileName){
        let arr = dataUrl.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)

        while(n--){
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], fileName, {type:mime})
    }
       
    
    create( url ) {
        var img = new Image();
            img.crossOrigin="anonymous"
            img.src = url;

        return img
    }

    findxy( res, e )
    {
        const orig_e = e
        if( this.isMobile ){
            if( e.touches && e.touches["0"] )
                e = e.touches["0"]
        }
        
        if ( res == 'down' )
        {
            if( this.img )
                this.ctx.drawImage( this.img, 0, 0);


            this.prevX = this.currX;
            this.prevY = this.currY;
            this.currX = e.clientX - this.canvas.getBoundingClientRect().left;
            this.currY = e.clientY - this.canvas.getBoundingClientRect().top;

            this.flag = true;
            this.dot_flag = true;
            if ( this.dot_flag )
            {
                this.ctx.beginPath();
                this.ctx.fillStyle = this.penColor;
                this.ctx.fillRect( this.currX, this.currY, this.penSize, this.penSize );
                this.ctx.closePath();
                this.dot_flag = false;
            }
        }
        if ( res == 'up' || res == "out" )
        {
            this.flag = false;
            /* this.setState({ value: this.edited }) */
            this.save()
            this.toggleRedBorder()
        }
        if ( res == 'move' )
        {
            orig_e.preventDefault()

            if ( this.flag )
            {
                this.edited = true
                this.prevX = this.currX;
                this.prevY = this.currY;
                this.currX = e.clientX - this.canvas.getBoundingClientRect().left;
                this.currY = e.clientY - this.canvas.getBoundingClientRect().top;
                this.draw();
            }
        }
    }


    render()
    {

        let redBorder = this.state.redBorder ? '.8rem solid red' : 'none'

        return (
            <div className='signatureContainer' ref='thisElement' >
                <div className='canvasContainer'>
                    <div className='canvasCenterWrapper' style={{ transition: 'all 0.2s ease', borderRight: redBorder }} >
                        <span className='icomoon_pencil icomoon_general' onClick={ e => this.erase() }></span>
                        <canvas className='signatureCanvas' id={ this.id } width={ this.w } height={ this.h }></canvas>
                        <div className='signatureName'>
                            {
                                this.name
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Signature


